import "./Label_module.css";
const Label_module = {
    labelWrapper: "labelWrapper__fb7daa628a843dae",
    label: "label__fb7daa628a843dae",
    disabled: "disabled__fb7daa628a843dae",
    required: "required__fb7daa628a843dae",
    tooltipAnchor: "tooltipAnchor__fb7daa628a843dae"
};
export { Label_module as default };
